import regeneratorRuntime from 'regenerator-runtime'

window.regeneratorRuntime = regeneratorRuntime



// WEBPACK FOOTER //
// ./app/runtimeConfig.js